/* eslint-disable react/jsx-no-literals -- launch landing page; intentionally English-only until launch */
/**
 * VowsEra — Coming Soon launch gate
 * Rendered for every route when VITE_COMING_SOON === 'true'.
 * Flip the flag to 'false' in .env.prod and rebuild to reveal the real site.
 */
import React from 'react';
import logoImg from '@assets/images/vowsera_256x256.png';
import './ComingSoonLaunch.scss';

const ComingSoonLaunch = () => (
  <div className="coming-soon-launch">
    <div className="coming-soon-launch__bg" aria-hidden="true" />
    <main className="coming-soon-launch__inner">
      <img
        src={logoImg}
        alt="VowsEra"
        className="coming-soon-launch__logo"
        width={120}
        height={120}
      />
      <span className="coming-soon-launch__eyebrow">
        <i className="bi bi-hourglass-split" /> Launching soon
      </span>
      <h1 className="coming-soon-launch__title">
        Something beautiful is on its way.
      </h1>
      <p className="coming-soon-launch__lede">
        VowsEra is the all-in-one wedding platform — vendor discovery, planning
        tools, guest experiences, and a personal wedding website, all in one
        place. We&apos;re putting the finishing touches in place.
      </p>
      <ul className="coming-soon-launch__features">
        <li><i className="bi bi-search" /> Curated vendors &amp; venues</li>
        <li><i className="bi bi-clipboard2-check" /> AI-assisted planning</li>
        <li><i className="bi bi-people" /> Guest portal &amp; RSVPs</li>
        <li><i className="bi bi-globe" /> Your own wedding website</li>
      </ul>
      <a
        className="coming-soon-launch__cta"
        href="mailto:hello@vowsera.com?subject=Notify%20me%20when%20VowsEra%20launches"
      >
        <i className="bi bi-envelope-heart" /> Notify me at launch
      </a>
      <footer className="coming-soon-launch__footer">
        &copy; {new Date().getFullYear()} VowsEra.com
      </footer>
    </main>
  </div>
);

export default ComingSoonLaunch;
